/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SupportDeliveryStatus } from './SupportDeliveryStatus';
import { SUPPORT_DELIVERY } from '../../../../constants/support';
const meta = {
    title: 'Features/AIChatWidget/SupportDeliveryStatus',
    component: SupportDeliveryStatus,
    parameters: { layout: 'padded' },
    args: { onRetry: () => undefined },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 400, padding: 16 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Sending = { args: { delivery: SUPPORT_DELIVERY.SENDING } };
export const Sent = { args: { delivery: SUPPORT_DELIVERY.SENT } };
export const FailedWithRetry = { args: { delivery: SUPPORT_DELIVERY.FAILED } };
